import { Logger } from '../config/logger'

/** This is meant to be used as a default error handler in situations when nothing specific is necessary to handle the error, other than prevent a crash, and log it */
export function errorCatcher(error: unknown) {
  Logger.error(error)
}
